/*
  Instant, interaction-independent handling of the ?qty= param for bulk buy.

  product-custom.js is a lazy-script (runs only after the first user action), so the
  URL-driven bulk-buy selection would otherwise not reflect until the user interacts.
  This file is loaded with `defer` (not lazy) so the correct qty tile is highlighted and
  the matching bundle image is shown immediately on load. It also keeps the main image in
  sync whenever a bulk-buy option is clicked.
*/
(function () {
  // xvd hides the multipack — leave the server-rendered defaults alone.
  // theme.liquid sets this flag from ?xvd=1 in the head.
  function isXvdTraffic() {
    try {
      return sessionStorage.getItem('xvd_found') === 'true';
    } catch (e) {
      return false;
    }
  }

  function getQtyFromUrl() {
    var qty = new URLSearchParams(window.location.search).get('qty');
    return ['2', '3'].indexOf(qty) !== -1 ? qty : null;
  }

  // Point an <img> at `url` (clearing srcset so it wins), remembering the original
  // once so a null url restores it.
  function applyImage(img, url) {
    if (!img) return;
    if (!img.dataset.originalSrc) {
      img.dataset.originalSrc = img.getAttribute('src') || '';
      img.dataset.originalSrcset = img.getAttribute('srcset') || '';
    }
    if (url) {
      img.setAttribute('srcset', '');
      img.setAttribute('src', url);
    } else {
      img.setAttribute('src', img.dataset.originalSrc);
      img.setAttribute('srcset', img.dataset.originalSrcset);
    }
  }

  // Swap the main product image AND the first thumbnail to the bundle image for the
  // selected qty. The image URLs come from the product metafields custom.multipack_image_2
  // / custom.multipack_image_3, rendered onto the .main-bulk-buy container as
  // data-multipack-image-2 / data-multipack-image-3 (see bulk-buy.liquid).
  // If there is no metafield image for the qty (e.g. qty 1), the originals are restored.
  window.updateMainImageForQty = function (qty) {
    var container = document.querySelector('.main-bulk-buy');
    var gallery = document.querySelector('media-gallery');
    if (!container || !gallery) return;

    var url = container.getAttribute('data-multipack-image-' + qty);

    var mainItem = gallery.querySelector('.product__media-item.is-active') ||
      gallery.querySelector('.product__media-item');
    applyImage(mainItem && mainItem.querySelector('.product__media img'), url);
    applyImage(gallery.querySelector('.thumbnail-list__item img'), url);

    // The zoom popup (product-media-modal) is a separate gallery built from the product
    // media, so it still shows the original single image. Swap its featured (first) image
    // too so the popup matches the selected bundle.
    applyImage(document.querySelector('.product-media-modal__content img'), url);
  };

  // Mirror the selected qty into every quantity input (main + sticky .main-add-to-basket
  // bar) so a URL-driven selection updates them too — not just clicks (which go through
  // product-custom.js' updatePriceDisplay).
  function syncQuantityInputs(qty) {
    document.querySelectorAll('.price_quantity_wrapper .quantity__input').forEach(function (input) {
      input.value = qty;
    });
    document.querySelectorAll('.updated-product-quantity').forEach(function (input) {
      input.value = qty;
      input.setAttribute('value', qty);
    });
  }

  // Reflect the selected qty's total price into the main/sticky price containers on load.
  // The click path uses product-custom.js' updatePriceDisplay (lazy — only after an
  // interaction), so on reload the price would otherwise stay at the single-unit price.
  // The selected tile already renders the correct discounted total (<b>) and compare-at
  // (<s>), matching what updatePriceDisplay computes, so we copy those straight over.
  function syncPriceDisplay(qty) {
    var bulkContainer = document.querySelector('.main-bulk-buy');
    var label = bulkContainer && bulkContainer.querySelector('label.bulk-buy[data-qty="' + qty + '"]');
    var block = label && label.querySelector('.bulk-buy-block');
    var saleEl = block && block.querySelector('b');
    if (!saleEl) return;

    var sale = saleEl.textContent.trim();
    var compareEl = block.querySelector('s');
    var compare = compareEl ? compareEl.textContent.trim() : '';

    var html = '<span class="price-item price-item--sale price-item--last">' + sale + '</span>';
    if (compare) {
      html += '<s class="price-item price-item--compare price-item--regular">' + compare + '</s>';
    }

    document.querySelectorAll(
      '.price_quantity_wrapper .price__container, product-info .price__container, .main-add-to-basket .price__container'
    ).forEach(function (c) {
      c.innerHTML = html;
    });
  }

  // Multipack products only: comfort-points.liquid renders the single-unit points and
  // product-custom.js (lazy) only updates them after an interaction, so on load — and on the
  // first click, which merely wakes the lazy scripts — they'd stay at the qty 1 value.
  // Copy the selected tile's data-points straight over.
  function syncComfortPoints(qty) {
    var container = document.querySelector('.main-bulk-buy');
    if (!container || container.getAttribute('data-multipack') !== 'true') return;
    var pointsEl = document.getElementById('comfortPoints');
    var label = container.querySelector('.bulk-buy-inner:not(.hidden) label.bulk-buy[data-qty="' + qty + '"]') ||
      container.querySelector('label.bulk-buy[data-qty="' + qty + '"]');
    var input = label && label.querySelector('.bulkbuy-input-element');
    var points = input && input.getAttribute('data-points');
    if (pointsEl && points) pointsEl.innerText = points;
  }

  function selectBulkBuy(qty) {
    var container = document.querySelector('.main-bulk-buy');
    if (!container) return;

    container.querySelectorAll('.bulkbuy-input-element').forEach(function (input) {
      input.checked = false;
      input.removeAttribute('checked');
    });

    var label = container.querySelector('label.bulk-buy[data-qty="' + qty + '"]');
    var input = label && label.querySelector('.bulkbuy-input-element');
    if (!input) return;

    input.checked = true;
    input.setAttribute('checked', 'checked');
    input.dispatchEvent(new Event('change', { bubbles: true }));
  }

  // Only place that writes ?qty= — product-custom.js' click handler reuses it.
  var syncUrlQty = (window.syncUrlQty = function (qty) {
    try {
      var url = new URL(window.location.href);
      if (url.searchParams.get("qty") === String(qty)) return;
      url.searchParams.set("qty", qty);
      window.history.replaceState({}, "", url);
    } catch (e) {}
  });

  function init() {
    var container = document.querySelector('.main-bulk-buy');
    if (!container || isXvdTraffic()) return;

    // Keep the main image and quantity inputs in sync whenever a bulk-buy option is clicked.
    container.addEventListener('click', function (event) {
      var label = event.target.closest('label.bulk-buy');
      if (!label) return;
      var clickedQty = label.getAttribute('data-qty');
      window.updateMainImageForQty(clickedQty);
      syncQuantityInputs(clickedQty);
      syncPriceDisplay(clickedQty);
      syncComfortPoints(clickedQty);
    });

    var qty = getQtyFromUrl();
    // On multipack products anything other than qty 2 or 3 defaults to 2.
    // Non-multipack products keep their own server-rendered default (qty 1).
    if (!qty) {
      if (container.getAttribute('data-multipack') !== 'true') {
        // Url only — selection, image and price are already correct server-side.
        var checked = container.querySelector('.bulkbuy-input-element:checked');
        var checkedLabel = checked && checked.closest('label.bulk-buy');
        syncUrlQty(checkedLabel ? checkedLabel.getAttribute('data-qty') : '1');
        return;
      }
      qty = '2';
    }
    selectBulkBuy(qty);
    syncUrlQty(qty);
    window.updateMainImageForQty(qty);
    syncQuantityInputs(qty);
    syncPriceDisplay(qty);
    syncComfortPoints(qty);
  }

  // Run on DOMContentLoaded so media-gallery.js (also deferred) is already upgraded.
  // With `defer`, readyState is 'interactive' when this runs and DOMContentLoaded has
  // not fired yet, so only skip the wait when the document is fully 'complete'.
  if (document.readyState === 'complete') {
    init();
  } else {
    document.addEventListener('DOMContentLoaded', init);
  }
})();
